import { useForm, Controller } from "react-hook-form";
import useGlobalMutation from "../../hooks/useGlobalMutation";
import { CountrySelector, FormContainer, TextInput } from "../shared";
import { CREATE_GROUP_SPECIALTY } from "./query";
import { clearCache } from "../../utils/cacheUtils";

const CreateGroupSpeciality = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        control,
    } = useForm({
        mode: "onChange",
    });

    const { submitMutation, loading } = useGlobalMutation(CREATE_GROUP_SPECIALTY, (cache) => {
        clearCache(cache, "allAbbvieProGroupSpecialties");
    });

    const handleSubmission = async (data) => {
        const { groupSpecialtyName, country } = data;
        const variables = {
            abbvieProGroupSpecialty: {
                groupSpecialtyName,
                country,
            },
        };
        const dataPath = "createAbbvieProGroupSpecialty.abbvieProGroupSpecialty";
        const isResultNull = await submitMutation(
            variables,
            dataPath,
            "Group Specialty Created Successfully"
        );
        isResultNull === null && reset();
    };

    return (
        <div className="row justify-content-center">
            <div className="col-md-10">
                <FormContainer
                    submitAction={handleSubmit(handleSubmission)}
                    customClass="custom-shadow p-5"
                    loading={loading}
                    backUrl="/abbvie-pro/group-specialties"
                    submitButtonText="Create Group Specialty"
                >
                    <h3 className="mb-5">Create Group Specialty</h3>

                    <div className="row">
                        <div className="col-md-6">
                            <TextInput
                                id="groupSpecialtyName"
                                labelText="Group Specialty"
                                {...register("groupSpecialtyName", {
                                    required: true,
                                })}
                                isInvalid={!!errors.groupSpecialtyName}
                                required
                            />
                        </div>
                        <div className="col-md-6">
                            <Controller
                                name="country"
                                render={({ field: { onChange, value }, ref }) => (
                                    <CountrySelector
                                        id="country"
                                        country={value || ""}
                                        labelText="Country"
                                        selectCountry={onChange}
                                        {...register("country", {
                                            required: true,
                                        })}
                                        required
                                        isInvalid={!!errors.country}
                                        ref={ref}
                                    />
                                )}
                                control={control}
                            />
                        </div>
                    </div>
                </FormContainer>
            </div>
        </div>
    );
};

export default CreateGroupSpeciality;
